import { Route, Switch } from 'react-router-dom';

// Only import and use 'containers' for your route handlers
import Application from './containers/Application';
import Home from './containers/Home';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/_jsx(Switch, {
  children: /*#__PURE__*/_jsx(Route, {
    path: "/",
    children: /*#__PURE__*/_jsx(Application, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/",
          component: Home
        })]
      })
    })
  })
});